<template>
      <div class="accountClosingCreate">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'accountClosing', params: {} }">
          Account Closing
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'accountClosingCreate', params: {} }">
            Create Account Closing
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Create Account Closing</v-card-title>
          <v-card-text>
            <accountClosing-form></accountClosing-form>
          </v-card-text>
        </v-card>
      </div>
    </template>
    <script>
    import AccountClosingForm from './AccountClosingForm.vue';

    export default {
      name: 'accountClosing',
      components: {
        AccountClosingForm
      },
      created() {
        this.$emit("showParent", false);
      }
    }
    </script>
    